/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Upload_BtnInputs */



/**
* | output |
* | --- |
* | "Upload signed scan" |
*
* @param {Nda_Upload_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_upload_btn = /** @type {((inputs?: Nda_Upload_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Upload_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléverser le scan signé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subir el escaneo firmado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar a digitalização assinada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica la scansione firmata")
	return /** @type {LocalizedString} */ ("Upload signed scan")
});